const styles = (theme) => ({
  table: {
    margin: 0,
    marginTop: 16,
    tableLayout: 'fixed',
    borderSpacing: 0,
  },
  hideContainer: {
    display: 'none'
  }
});

export default styles;
